var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-modal',{staticClass:"follow-modal",attrs:{"id":_vm.myId,"hide-footer":""}},[_c('div',{staticClass:"head"},[_vm._v("\n\t\t"+_vm._s(_vm.$t('group.members'))+"\n\t")]),_c('div',{staticClass:"follow-panel"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }